import React from "react";
import moment from "moment";
import { Trans, useTranslation } from "react-i18next";
import { FormGroup, ControlLabel, Input, HelpBlock } from "components/bootstrap";
import { TimeUnitInput } from "components/common";
import { extractDurationAndUnit } from "components/common/TimeUnitInput";
import NumberUtils from "util/NumberUtils";
import ValidationErrors from "./ValidationErrors";
const TIME_UNITS = ["HOURS", "MINUTES", "SECONDS"];
const AbsoluteThresholdForm = ({ config, handleConfigFieldChange, validation }) => {
  const { t } = useTranslation("enterprise_license");
  const executeEvery = extractDurationAndUnit(
    moment.duration(config.execute_every_seconds, "seconds").asMilliseconds(),
    TIME_UNITS
  );
  const handleExecuteEveryChange = (nextValue, nextUnit) => {
    const seconds = moment.duration(nextValue, nextUnit.toLowerCase()).asSeconds();
    handleConfigFieldChange("execute_every_seconds", seconds.toString());
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormGroup, { validationState: validation.errors.threshold ? "error" : null }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "threshold",
      name: "threshold",
      label: t("license.traffic.absolute_threshold_label"),
      type: "number",
      min: 0,
      step: 0.01,
      value: NumberUtils.bytesToGiB(config.threshold),
      help: t("license.traffic.absolute_threshold_help"),
      onChange: (e) => handleConfigFieldChange("threshold", String(NumberUtils.giBToBytes(Number(e.target.value)))),
      required: true
    }
  ), /* @__PURE__ */ React.createElement(ValidationErrors, { errors: validation.errors.threshold })), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(ControlLabel, null, t("license.traffic.time_range_mode")), /* @__PURE__ */ React.createElement(HelpBlock, null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "license.traffic.absolute_time_range_help", components: { strong: /* @__PURE__ */ React.createElement("strong", null) } }))), /* @__PURE__ */ React.createElement(FormGroup, { validationState: validation.errors.execute_every_seconds ? "error" : null }, /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label: t("license.traffic.execute_every"),
      update: handleExecuteEveryChange,
      value: executeEvery.duration,
      unit: executeEvery.unit,
      units: TIME_UNITS,
      help: t("license.traffic.execute_every_help"),
      required: true
    }
  ), /* @__PURE__ */ React.createElement(ValidationErrors, { errors: validation.errors.execute_every_seconds })));
};
export default AbsoluteThresholdForm;
